import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import _ from 'underscore';

import { acBilet } from '../actions/acBilet'

class Paytable extends React.Component {

    constructor() {
        super();
        this.state = {

        };
    }
    fact(n) {
        var f = 1;
        for (var i = 2; i <= n; ++i)
            f *= i;
        return f;
    }
    comb(n, k) {
        var aux = 1;
        for (var i = k + 1; i <= n; ++i)
            aux *= i;
        return aux / this.fact(n - k);
    }
    oddMaxWin(val2, i, findBilet) {
        var minBile_GameType = Math.min(findBilet.gameType.split('/')[0], findBilet.sum.length);
        var sliceDef = findBilet.sumDefault.slice(0, minBile_GameType)
        var maxOdd
        if (val2 < this.props.defaultVal.max_win) {
            maxOdd = Math.round(val2 / findBilet.miza * 100) / 100.0
        } else {
            maxOdd = Math.round(sliceDef[i] / findBilet.miza * 100) / 100.0
        }
        return maxOdd
    }
    showTabelInfo(findBilet) {
        if (findBilet && findBilet.miza !== 0) {
            var minBile_GameType = Math.min(findBilet.gameType.split('/')[0], findBilet.sum.length);
            var slice = findBilet.sum.slice(0, minBile_GameType)
            // var system = findBilet.checked[0]
            var arr = slice.map((val2, i) => {
                if (val2 !== 0) {
                    return (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            {/* <td>{this.comb(i + 1, system)}</td> */}
                            <td>
                                {/* {'x ' + findBilet.coteFixe[i]} */}
                                {'x ' + this.oddMaxWin(val2, i, findBilet)}
                            </td>
                            <td>
                                {val2 + ' ' + this.props.defaultVal.currency}
                            </td>
                        </tr>
                    )
                } else {
                    return undefined
                }
            })
            var arr2 = _.compact(arr)
            var arr1 = arr2.splice(0, Math.round(arr2.length / 2));
            return (
                [arr1, arr2].map((val, i) => {
                    return (

                        <tbody key={i}>
                            {val}
                        </tbody>
                    )
                })
            )
        } else {
            var default_tabel = []
            for (let j = 0; j < this.props.activeLot.odds.length; j++) {
                default_tabel.push(
                    <tbody key={j}>
                        <tr key={j}>
                            <td>{j + 1}</td>
                            {/* <td>{this.comb(i + 1, system)}</td> */}
                            <td>
                                {'x ' + this.props.activeLot.odds[j]}
                            </td>
                            <td>
                                -
                    </td>
                        </tr>

                    </tbody>
                )
            }
            return default_tabel
        }

    }
    changeSum(val) {
        var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab });
        var max = this.props.defaultVal.max_bet
        var min_bet = this.props.defaultVal.min_bet
        var min = 0
        var sumTicket = parseFloat(findBilet.miza)
        if (val === 'up') {
            var newSum = parseFloat(sumTicket) + min_bet

            if (sumTicket >= max) { newSum = max }

            var values = {
                position: findBilet.position,
                miza: Math.round(newSum * 100.0) / 100.0
            }
            this.props.acBilet(['biletMiza', values])
        }

        if (val === 'down') {
            newSum = parseFloat(sumTicket) - min_bet

            if (sumTicket <= min) { newSum = min }

            values = {
                position: findBilet.position,
                miza: Math.round(newSum * 100.0) / 100.0
            }
            this.props.acBilet(['biletMiza', values])
        }
    }
    clearOnFocus(event) {
        if (parseInt(event.target.value, 10) === 0) {
            event.target.value = '';
        }
    }
    onBlur(event) {
        if (event.target.value === '') {
            event.target.value = 0;
        }
    }
    updateMiza(val, e) {
        // if (val.valid === true) {
        var miza = e.target.value

        if ((isNaN(miza) === true) && (miza !== '')) {
            miza = 0;
        }
        if (miza >= this.props.defaultVal.max_bet) {
            miza = this.props.defaultVal.max_bet;
        }
        if (miza < 0) {
            miza = 0;
        }
        var values = {
            position: val.position,
            miza: miza
        }
        this.props.acBilet(['biletMiza', values])
        // }
    }
    mizaToFixed(val) {
        if (val && val.length > 0) {
            let punct = val.endsWith('.')
            if (punct === true) {
                return val
            } else {
                return Math.round(val * 100) / 100
            }
        } else {
            return val
        }
    }
    render() {
        var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab });
        // console.log('Paytable***', this.props, findBilet);
        var miza = 0
        var classMiza, disab
        if (findBilet) {
            miza = findBilet.miza
        } else {
            classMiza = 'disab'
        }

        if (classMiza === 'disab') {
            disab = true
        } else {
            disab = false
        }
        return (
            <div className="con-paytable">
                <div className="module-header">
                    <span style={{ float: 'left' }}>{this.props.multiLang.possWin2.txt}
                        <img id="info-img" src="img/icon/info.svg" alt="" title={this.props.multiLang.possWinInfo.txt} />
                        <p className="possWinInfo">{this.props.multiLang.possWinInfo.txt}</p>
                    </span>
                    <div className="con-con-miza">
                        <span>{this.props.multiLang.enterStake.txt}</span>
                        <span>
                            <div className={"con-miza " + classMiza}>
                                <button disabled={disab} className="minus" onClick={this.changeSum.bind(this, 'down')}><div>-</div></button>
                                <input className="cash-in" type="text"
                                    onFocus={this.clearOnFocus.bind(this)}
                                    onBlur={this.onBlur.bind(this)}
                                    value={this.mizaToFixed(miza)}
                                    onChange={this.updateMiza.bind(this, findBilet)}
                                />
                                <button disabled={disab} className="plus" onClick={this.changeSum.bind(this, 'up')}>
                                    <div>+</div>
                                </button>
                            </div>
                        </span>
                    </div>
                </div>
                <div className="con_table table_winArray">
                    <table className="paytable">
                        <thead>
                            <tr>
                                <th>{this.props.multiLang.hitsNb.txt}</th>
                                {/* <th>Nr. Comb. câștigătoare</th> */}
                                <th>{this.props.multiLang.odds.txt}</th>
                                <th>{this.props.multiLang.possWin.txt}</th>
                            </tr>
                        </thead>
                        {this.showTabelInfo(findBilet)}
                    </table>
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        activeLot: state.activeLot,
        biletTab: state.biletTab,
        bilete: state.bilete,
        defaultVal: state.defaultVal,
        rundaSelectata: state.rundaSelectata,
        multiLang: state.multiLang
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acBilet: acBilet
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(Paytable);